export enum dashboardChartFilterEnum {
    ThisWeek = 0,
    ThisMonth = 1,
    LastWeek = 2,
    LastMonth = 3,
}



export const dashboardChartFilterArray = [
    {
        valueMember: dashboardChartFilterEnum.ThisWeek,
        displayMember: 'This Week'
    },
    {
        valueMember: dashboardChartFilterEnum.ThisMonth,
        displayMember: 'This Month'
    },
    {
        valueMember: dashboardChartFilterEnum.LastWeek,
        displayMember: 'Last Week'
    },
    {
        valueMember: dashboardChartFilterEnum.LastMonth,
        displayMember: 'Last Month'
    },
]
